


$(function(){
  $('.cart-ajax .product-form-quick-buy button[type="submit"]').click(function(event){
    var id = $(this).closest('form').find('select[name="id3"]').val();
    $(this).closest('form').find('input[name="id"]').attr('value',id);
    $(".cart-ajax .cart-ajax__body").animate({ scrollTop: 0 }, "fast");
  });
  $('#Cart-icon').on('click', function(){
    $('.cart-ajax .swatch-product--color:first-child').click();
  });
  $('.cart-ajax').on('click','.swatch-product',function(){
    var option = $(this).data('swatch-option');
    var value = $(this).data('swatch-value');
    var image = $(this).parents('.selector-wrapper').find('select > option[value="'+ value +'"]').data('image');
    $(this).parents('.ajax-related__product-wrapper').find('.ajax-related__product-image').css('background-image', 'url('+image+')');
    $(this).closest('.product-swatches').find('select[data-index="option2"] option').each(function(){
      var label = $(this).val() + ' / ' + value;
      $(this).text(label);
    });
  });
  
  //UPDATE PRODUCT VARIANT NAME IN AJAX CART ON SWATCH CLICK
   $('.cart-ajax .product-form-quick-buy .swatch-product').click(function(event){
    $(this).closest('.ajax-related__text').find('.swatch__header__color').html(' - '+$(this).attr("name"));
     $(this).closest('.swatch__wrapper').find('.is-active').removeClass("is-active");
     $(this).addClass("is-active");
  });
  
  
  
  $( '#shopify-section-product-new .swatch-product--color' ).on('click',function(){
    var $form = $(this).parents('#shopify-section-product-new');
    var price = $(this).data('variant-price');
    var old_price = $(this).data('variant-old-price');
    $form.find('[data-product-price]').html(price);
    var $old = $form.find('[data-compare-price]');
    if($old.length > 0) {
      $old.html(old_price);
    }
    var material = $(this).data('variant-material');
    if(material != ""){
      $(".swatch__header__color.material").html(material);
      $(".materials_container ").removeClass("hidden");
    }
    else{
      $(".materials_container ").addClass("hidden");
    }
    var selectedSize=$(this).attr("data-selected-size");
    if( selectedSize != ""){
      $('.product-form .product-swatches .swatch__size-container .swatch-product--size[data-swatch-value="'+selectedSize+'"]')[0].click();
    }
  });  
  //DISPLAY CORRECT INVENTORY ON PAGE LOAD
  // $(".product-form").find(".swatch-product--color.is-active")[0].click();

  $(".product-form").find(".swatch-product--size").each(function( index ) {
    if ($(this).hasClass("is-active")) $( this )[0].click();
  });
  // $(".product-form-mini__container").find(".swatch-product--color").each(function( index ) {
  //   if ($(this).hasClass("is-active")) $( this )[0].click();
  // });

  //UPDATE PRODUCT IMAGE ON CLICK ON COLOR BUBBLE IN ADD TO CART POPUP
  $(".product-form-mini").find(".swatch-product--color").each(function( index ) {
    $(this).on("click", function(){
      console.log($(this)[0].classList.item(2));
      console.log($(".product-form").find("."+$(this)[0].classList.item(2)));
      $(".product-form").find("."+$(this)[0].classList.item(2))[0].click();
    });
  });

  //FILTERING PRODUCTS BY BEST SELLERS FIRST
  $(".collection-container").find("a").each(function() {
    var $this = $(this);       
    var _href = $this.attr("href"); 
    if (_href.indexOf("sort_by=best-selling") < 0){
      $this.attr("href", _href + '?sort_by=best-selling'); 
    }
  });

    var i;
  for (i = 0; i < 7; i++) {
    $(".swatch__wrapper--size").append("<div class='size-swatch-button-container'> </div>");
  } 
  
  
    
  var topPadding = $("div.site-header").innerHeight()+25;

  var $desc = $('.collection-filter__container');
  $desc.hcSticky({
    stickTo: '.collection-wrapper',
    top: topPadding,
    responsive: {
      1024: {
        disable:true
      }
    }
  });
  
    
  //SORT SWATCHES IF LIMITED EDITION VARIANTS FOR PRODUCT
  if($(".product-form .swatch__wrapper.option-1").find(".swatch-product--color.limited").length >0){
    $(".product-form .swatch__wrapper.option-1").find(".swatch-product--color.limited").each(function( index ) {
      $(this).appendTo($('.product-editions-container .limited-edition-container .swatches-container'));
    }); 
    $(".product-form .swatch__wrapper.option-1").find(".swatch-product--color.classic").each(function( index ) {
      $(this).appendTo($('.product-editions-container .classic-edition-container .swatches-container'));
    }); 
    if(window.innerWidth <=1024 ){
      $(".product-form .product-editions-container").css("display", "flex");
    }
    else{
      $(".product-form .product-editions-container").css("display", "block");
    }
  }
  
    
  //DUPLICATE FIT TEXT TO SIZE POPUP
  $(".fit_container").clone().prependTo(".size-guide__measurement");
  $(".size-guide__measurement .fit_container").css("display", "block");
  
  
    //SCROLL TO SIZE ON ADDTOCART STICKY BUTTON + ADD WARNING
  $(".product-form-mini .product-form-mini__footer .button span").click(function() {
    if($(".product-meta .product-form .button.button--full").prop('disabled')){
      $(".product-form .swatch__size-container").addClass("warning");
      var element = document.getElementById("product-header");
      element.scrollIntoView({ block: 'start',  behavior: 'smooth' }); 
    }
  });
  
  //ON SIZE CLICK, REMOVE WARNINGS, SAVE SIZE TO EACH COLOR SWATCHES, PRESELECT KLAVIYO BACK IN STOCK SELECT IF POSSIBLE
  $(".product-form .product-swatches .swatch__size-container .swatch-product--size").click(function() {
    $(".product-form .product-swatches .swatch__size-container").removeClass("warning");
    var selectedSize=$(this).data("swatch-value");
    $(".product-form .swatch-product--color").each(function(){
      $(this).attr("data-selected-size",selectedSize);
    });
    updateLowInventoryBadge();
    });
  
  
});

function updateLowInventoryBadge(){
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const variantId = urlParams.get('variant')
  if(variantId!=""){
    var quantity = window.inventories[variantId].quantity;
    var showInventory = true;
    if (quantity <= 0 || quantity > theme.settings.inventoryThreshold || theme.settings.inventoryThreshold == false) {
      showInventory = false;
    }
    toggleInventoryQuantity(showInventory, quantity);
  }
}
function toggleInventoryQuantity(show, qty) {
  if (show) {
    $(".product__inventory")
      .removeClass('hide')
      .text(theme.strings.stockLabelPDP.replace('[count]', qty));
  } else {
    $(".product__inventory").addClass('hide');
  }
};

$( document ).ready(function() {
  $(".instafeed__footer").before("<div class='instamodal'> </div>");
  isFeedReady();

});

function isFeedReady(){
  if($('#insta-feed').children().length != 0){
    updateInstaFeed();
    $(".instafeed-lightbox .profile-picture").each(function() {
      $(this).attr("data-src","//wolfandshepherd.com/cdn/shop/t/198/assets/wolf_logo.jpg?v=128403522457436398041650990645");
    });
  }
  else{
    setTimeout(isFeedReady, 2000);
  }

}

function updateInstaFeed(){
  $(".instafeed-lightbox ").each(function() {
    //$('.instamodal').append($(this)); 
  });
  $(".js-lazy-image").each(function() {
    $(this).attr('src', $(this).attr('data-src'));
  });
  $(".instafeed-container").each(function(){
	$(this).attr('style', 'width: 100%;padding-top: 100%;');
    $(this).parent().addClass('slider-container');
  });
  $("#insta-feed").slick({
    slide: '.slider-container',
    arrows: !0,
    vertical: !1,
    prevArrow: '<div class="slick-arrow slick-prev wolf-arrow"></div>',
    nextArrow: '<div class="slick-arrow slick-next wolf-arrow wolf-arrow--right"></div>',
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: !0,
    dots: !1,
    responsive: [{
      breakpoint: 1e3,
      settings: {
        arrows: !1,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: !0,
        centerPadding: "15%"
      }
    }, {
      breakpoint: 620,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: !0,
        centerPadding: "15%"
      }
    }]
  }) 
}


$("#gorgias-web-messenger-container").css("height", "150px");